import { render, staticRenderFns } from "./subcontract.vue?vue&type=template&id=6c48deed&scoped=true"
import script from "./subcontract.vue?vue&type=script&lang=js"
export * from "./subcontract.vue?vue&type=script&lang=js"
import style0 from "./subcontract.vue?vue&type=style&index=0&id=6c48deed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c48deed",
  null
  
)

export default component.exports